import {createRouter, createWebHistory} from 'vue-router';
import auth from '@/commons/authService';
import routerPage from './routerPage.js';
import commonFn from '@/commons/commonFunction.js';
import popupUtil from '@/commons/popupUtil.js';
import {useContextStore} from '@/stores/contextStore';
import PrivacyTerms from '@/commons/wildcards/constants/PrivacyTerms';

const routes = [
  {
    path: '',
    redirect: '/home',
    meta: {
      anonymous: true,
    },
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach((toRouter, from, next) => {
  // khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  // do tình huông tải file js chậm
  // trong after sẽ ẩn mask loading đi
  // Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();
  window._cacheTitlePage = [];

  // hide all popup
  // TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll();

  // Kiểm tra guard thỏa thuận
  let guardRouter = guardTermsPrivacy(toRouter.path);
  if (guardRouter) {
    next(guardRouter);
    return;
  }

  // trang không authen
  if (toRouter.meta.anonymous) {
    next();
    return;
  }
  // kiểm tra authen -> fail redirect login
  if (!auth.isAuthenticated()) {
    const contextStore = useContextStore();
    contextStore.login(toRouter.path);
    return;
  }

  // commonFn.checkPermissionDVC(toRouter);

  // check theo quá hạn license, show thông báo và logout luôn
  if (commonFn.checkRouterExpiredDate()) {
    commonFn.checkWarningExpired();
    commonFn.unmask();
    return;
  }

  // check theo quyền hạn vai trò
  // + Nếu là đường dẫn mặc định thì check xem có quyền ko,
  //   nếu ko có quyền thì redirect đến màn hình Getting stated
  const isValid = commonFn.checkPermissionByRoute(toRouter);

  if (!isValid) {
    location.href = '/403';
  }

  // default
  next();
});

/**
 * "bảo vệ" màn hình xác nhận thỏa thuận/ chính sách
 * vqphong - 04/06/2024
 */
const guardTermsPrivacy = toRouterPath => {
  const contextStore = useContextStore();
  const termsPrivacy = contextStore.context?.Context?.TermsPrivacy;
  const isCheckLicense = contextStore.context?.Context?.IsCheckLicense;
  // Kiểm tra điều kiện để hiển thị màn hình terms-privacy
  let shouldShowTermsPrivacy = false;
  if (termsPrivacy && termsPrivacy !== null) {
    if (termsPrivacy.IsAdmin === true) {
      // Nếu là admin, phải có ListTermsOfPurchase và có length > 0
      shouldShowTermsPrivacy = termsPrivacy.ListTermsOfPurchase && termsPrivacy.ListTermsOfPurchase.length > 0;
    } else {
      // Nếu không phải admin, phải có ListTermsOfService và có length > 0
      shouldShowTermsPrivacy = termsPrivacy.ListTermsOfService && termsPrivacy.ListTermsOfService.length > 0;
    }

    const caseOfSubApp = termsPrivacy?.caseOfSubApp;
    if (caseOfSubApp != null) {
      const termsOfService = termsPrivacy?.ListTermsOfService?.filter(i => i.ProductCode !== 'IHOS') || [];
      const termsOfPurchase = termsPrivacy?.ListTermsOfPurchase?.filter(i => i.ProductCode !== 'IHOS') || [];

      switch (caseOfSubApp) {
        case PrivacyTerms.NotCheckLicense: // trường hợp không lấy được thông tin suman hoặc isCheckLicense = false
          if (isCheckLicense == false) {
            if (termsPrivacy.IsAdmin === true) {
              // Nếu là admin, phải có ListTermsOfPurchase và có length > 0
              shouldShowTermsPrivacy = termsOfService.length > 0 || termsOfPurchase.length > 0;
            } else {
              // Nếu không phải admin, phải có ListTermsOfService và có length > 0
              shouldShowTermsPrivacy = termsOfService && termsOfService.length > 0;
            }
          } else {
            shouldShowTermsPrivacy = false;
          }
          break;
        case PrivacyTerms.TwoTerms: // TH1,2: Hiển thị cả 2 thỏa thuận -> case theo cả IsAdmin
        case PrivacyTerms.OneTerm:
          if (termsPrivacy.IsAdmin === true) {
            // Nếu là admin, phải có ListTermsOfPurchase và có length > 0
            shouldShowTermsPrivacy = termsOfService.length > 0 || termsOfPurchase.length > 0;
          } else {
            // Nếu không phải admin, phải có ListTermsOfService và có length > 0
            shouldShowTermsPrivacy = termsOfService && termsOfService.length > 0;
          }
          break;
        case PrivacyTerms.UsageOnly: // TH3: Chỉ hiển thị thỏa thuận sử dụng -> case có thỏa thuận sử dụng mới hiển thị
          shouldShowTermsPrivacy = termsOfService && termsOfService.length > 0;
          break;
        default:
          break;
      }
    } else {
      shouldShowTermsPrivacy = false;
    }
  }

  // nếu có TermsPrivacy và có dữ liệu trong các list, và không phải các trang đặc biệt
  if (
    shouldShowTermsPrivacy &&
    toRouterPath !== '/logout' &&
    toRouterPath !== '/login' &&
    toRouterPath !== '/terms-privacy'
  ) {
    return '/terms-privacy';
  }
  // nếu không có TermsPrivacy hoặc không có dữ liệu, và đang ở trang terms-privacy thì redirect về home
  else if (!shouldShowTermsPrivacy && toRouterPath === '/terms-privacy') {
    return '/';
  }

  return null;
};

export default router;
